// ============================================================
// SILSILÄ theme — interactions (dependency-free)
// nav, reveals (+failsafe), magnetic buttons, stat counters,
// product thumbnail switching.
// ============================================================
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* mobile nav toggle */
  var toggle = document.querySelector('.nav__toggle');
  var links = document.querySelector('.nav__links');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      var open = links.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* buttons dodge slightly AWAY from the cursor (opposite direction) */
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    var bindDodge = function (btn) {
      if (btn.dataset.dodge) return;
      btn.dataset.dodge = '1';
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var mx = e.clientX - r.left - r.width / 2;
        var my = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (mx * -0.18) + 'px,' + (my * -0.26) + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    };
    document.querySelectorAll('.btn').forEach(bindDodge);
    // re-bind for buttons added later (cart drawer, etc.)
    window.SILSILA_bindDodge = function () { document.querySelectorAll('.btn').forEach(bindDodge); };
  }

  /* reveal on scroll — content visible by default; hidden only when JS runs */
  var items = [].slice.call(document.querySelectorAll('.section-h, .pcard, .concern, .value, .review, .hero__copy, .hero__media, .story__text, .story__media, .stat'));
  if (!reduce && 'IntersectionObserver' in window && items.length) {
    items.forEach(function (el) { el.classList.add('is-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el, i) { el.style.setProperty('--reveal-delay', (i % 4 * 0.07) + 's'); io.observe(el); });
    // failsafe: never let content stay hidden (hidden tab / headless)
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 2600);
  }

  /* count-up numbers (hero proof + story stats) */
  var stats = [].slice.call(document.querySelectorAll('[data-count]'));
  if (stats.length && !reduce && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, end = parseFloat(el.getAttribute('data-count')) || 0, suffix = el.getAttribute('data-suffix') || '', start = performance.now();
        (function step(now) {
          var t = Math.min((now - start) / 1400, 1), eased = 1 - Math.pow(1 - t, 3);
          el.textContent = Math.round(end * eased).toLocaleString() + suffix;
          if (t < 1) requestAnimationFrame(step);
        })(start);
        sio.unobserve(el);
      });
    }, { threshold: 0.6 });
    stats.forEach(function (el) { sio.observe(el); });
  } else {
    stats.forEach(function (el) { el.textContent = (parseFloat(el.getAttribute('data-count')) || 0).toLocaleString() + (el.getAttribute('data-suffix') || ''); });
  }

  /* sticky header shadow on scroll */
  var header = document.getElementById('SiteHeader');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- cart drawer ---------- */
  var CFG = window.SILSILA || { moneyFormat: '{{amount}}', cartUrl: '/cart', allUrl: '/collections/all' };
  var drawer = document.getElementById('CartDrawer');
  var body = document.getElementById('CartDrawerBody');
  var foot = document.getElementById('CartDrawerFoot');

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(CFG.moneyFormat).replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, v);
  }
  function setCount(n) { document.querySelectorAll('.nav__count').forEach(function (c) { c.textContent = '(' + n + ')'; }); }
  function updateBar(cart) {
    var bar = document.getElementById('CartBar');
    if (!bar) return;
    if (cart.item_count > 0) {
      var cEl = document.getElementById('CartBarCount'), tEl = document.getElementById('CartBarTotal');
      if (cEl) cEl.textContent = cart.item_count;
      if (tEl) tEl.textContent = money(cart.total_price);
      bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false');
    } else { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderCart(cart) {
    setCount(cart.item_count);
    updateBar(cart);
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><span class="cart-drawer__leaf" aria-hidden="true">🌿</span><p>Your cart is empty.</p><a href="' + CFG.allUrl + '" class="btn btn--terra" data-cart-close>Shop supplements</a></div>';
      if (foot) foot.innerHTML = '';
      return;
    }
    var html = '';
    cart.items.forEach(function (it) {
      var src = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var img = src ? '<img src="' + src + '" alt="">' : '';
      html += '<div class="cd-item"><a href="' + it.url + '" class="cd-item__img">' + img + '</a>' +
        '<div class="cd-item__info"><a href="' + it.url + '" class="cd-item__title">' + esc(it.product_title) + '</a>' +
        (it.variant_title ? '<p class="cd-item__variant">' + esc(it.variant_title) + '</p>' : '') +
        '<div class="cd-item__qty"><button type="button" data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
        '<div class="cd-item__price">' + money(it.final_line_price) + '</div></div>';
    });
    body.innerHTML = html;
    if (foot) foot.innerHTML = '<div class="cd-subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<a href="' + CFG.cartUrl + '" class="btn btn--outline">View cart</a><a href="/checkout" class="btn btn--terra">Checkout</a>';
    if (window.SILSILA_bindDodge) window.SILSILA_bindDodge();
  }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function openCart() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function closeCart() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }

  if (drawer) {
    getCart().then(renderCart);
    document.querySelectorAll('.nav__cart, [data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); getCart().then(renderCart).then(openCart); });
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) closeCart();
      var q = e.target.closest('[data-qty]');
      if (q) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: q.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-qty'), 10) }) })
          .then(function (r) { return r.json(); }).then(renderCart);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    // AJAX add-to-cart on product pages -> refresh + open the drawer
    var pform = document.querySelector('.product-form');
    if (pform) {
      pform.addEventListener('submit', function (e) {
        e.preventDefault();
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(pform) })
          .then(function (r) { return r.json(); }).then(function () { return getCart(); }).then(renderCart).then(openCart)
          .catch(function () { pform.submit(); });
      });
    }
  }

  /* ---------- login / account popup ---------- */
  var authModal = document.getElementById('AuthModal');
  function authClose() { if (authModal) { authModal.classList.remove('is-open'); authModal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
  function authOpen(view) {
    if (!authModal) return;
    if (view) authModal.querySelectorAll('[data-auth-view]').forEach(function (v) { v.hidden = v.getAttribute('data-auth-view') !== view; });
    authModal.classList.add('is-open'); authModal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  document.querySelectorAll('[data-login-open]').forEach(function (b) {
    b.addEventListener('click', function () { authOpen('login'); });
  });
  if (authModal) {
    authModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-auth-close]')) { authClose(); return; }
      var to = e.target.closest('[data-auth-to]');
      if (to) { authOpen(to.getAttribute('data-auth-to')); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') authClose(); });
    // if a login/register attempt failed, Shopify reloads with ?... — reopen the popup so errors show
    if (authModal.querySelector('.errors, .form__message, [id*="error"]')) authOpen('login');
  }

  /* product thumbnail switching */
  var mainImg = document.getElementById('ProductMainImage');
  if (mainImg) {
    document.querySelectorAll('.product-page__thumb').forEach(function (t) {
      t.addEventListener('click', function () { mainImg.src = t.getAttribute('data-src'); });
    });
  }

  /* product image hover-zoom (magnify the region under the cursor) */
  var zoom = document.getElementById('ProductZoom');
  if (zoom && mainImg && !reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var ZOOM = 2.4;
    zoom.addEventListener('pointerenter', function () { zoom.classList.add('is-zooming'); mainImg.style.transform = 'scale(' + ZOOM + ')'; });
    zoom.addEventListener('pointermove', function (e) {
      var r = zoom.getBoundingClientRect();
      var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
      var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
      mainImg.style.transformOrigin = x + '% ' + y + '%';
    });
    zoom.addEventListener('pointerleave', function () { zoom.classList.remove('is-zooming'); mainImg.style.transform = ''; mainImg.style.transformOrigin = 'center'; });
  }
})();
